import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import AMPLITUDE from '@/constants/amplitude'
import useAmplitudeTestAB from '@/hooks/useAmplitudeTestAB'
import { useCROTon057 } from '@/services/amplitude/experiments/useCROTon057'

import Icon from '../Icon'
import styles from './styles.module.css'

function makeid(length: number) {
  let result = ''
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

const WhatsappButton = () => {
  const router = useRouter()
  const { activeVariant } = useAmplitudeTestAB(
    AMPLITUDE.FLAGS.FLAG_TON_WHATSAPP_AND_CHAT_WIDGET,
    true
  )

  const { isVarB } = useCROTon057()

  const isRendaTon = router.pathname.startsWith('/renda-ton')
  const isLimiteConta = router.pathname.startsWith('/limite-da-conta')
  const isCapitalGiro = router.pathname.startsWith('/capital-de-giro')
  const isAdquiraPage = router.pathname.startsWith('/adquira')
  const isSeguros = router.pathname.startsWith('/seguros')
  const isTapton = router.pathname.startsWith('/tapton')
  const isTapToPayNoIphone = router.pathname.startsWith('/tap-to-pay-no-iphone')
  const isCatalog = router.pathname.startsWith('/catalogo')
  const isRevendedor = router.query.utm_source === 'revendedor'
  const isLPTapton = router.pathname.startsWith('/lp-tapton')

  const shouldHidden =
    isAdquiraPage ||
    isRendaTon ||
    isSeguros ||
    isTapton ||
    isTapToPayNoIphone ||
    isLimiteConta ||
    isCapitalGiro ||
    isRevendedor ||
    isCatalog ||
    isLPTapton

  const numberPhone = isVarB ? '551150281494' : '551150396697'

  const [wid, setWid] = useState<string>('')

  useEffect(() => {
    // Só roda no client
    if (typeof window !== 'undefined') {
      let storedWid = localStorage.getItem('WID')
      if (!storedWid) {
        storedWid = makeid(8)
        localStorage.setItem('WID', storedWid)
      }
      setWid(storedWid)
    }
  }, [])

  const whatsappMessage =
    'Protocolo de Atendimento: ' +
    wid.toUpperCase() +
    ' | Oi!  Você pode me ajudar?'

  return activeVariant === 'on' ? (
    <a
      id="button-whatsapp"
      target="_blank"
      href={`https://api.whatsapp.com/send?phone=${numberPhone}&text=${encodeURIComponent(
        whatsappMessage
      )}`}
      className={`btn btn-large p-16 md:px-24 font-bold flex gap-8 ${
        shouldHidden ? '!hidden' : ''
      } ${styles.WhatsappButton}`}
      rel="noreferrer"
    >
      <Icon
        name="whatsapp"
        className="w-24 min-w-[24px] max-w-full h-24 min-h-[24px] max-h-full text-display-900 fill-current"
      />
      Peça no WhatsApp
    </a>
  ) : (
    <></>
  )
}

export default WhatsappButton
